import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useEffect, useRef, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Brands from '../users/Brands';
import { TOOLTIP_STYLES, getFixedValue, getDateformatUsingSeconds, SOCIAL_PLATEFORM } from '../../utils/constant';
import profilePlatformIcon from '../../assets/images/icons/profilePlatformIcon.svg'
import imageIconBlack from '../../assets/images/icons/imageIconBlack.svg'
import tagIcon from '../../assets/images/icons/tagIcon.svg'
import linkIcon from '../../assets/images/icons/linkIcon.svg'
import instagramIcon from '../../assets/images/icons/instaIcon.svg'
import youtubeIcon from '../../assets/images/icons/YouTube2.svg'
import infoIcon from '../../assets/images/icons/infoIcon.svg'
import likeIcon from '../../assets/images/icons/likeIcon.svg'
import eyeIcon from '../../assets/images/icons/openEye.svg'
import profileCommentIcon from '../../assets/images/icons/profileCommentIcon.svg'
import { useSelector } from 'react-redux';

const UltimateProfileSummary = ({ details, influencerDetails }) => {
    const [showAllHastags, setShowAllHastags] = useState(false);
    const [overviewPostTab, setOverviewPostTab] = useState("topMostPost");
    const [childElementIdForScroll, setChileElementIdForScroll] = useState("#platforms")
    const { isScreenZoomed } = useSelector(state => state.commonSlice);
    const contentRef = useRef(null);

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 4,
            slidesToSlide: 4,
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: isScreenZoomed ? 4 : 5,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        },
    };

    const getAllHashtags = () => {
        const hashtagMap = {};
        details.forEach((item) => {
            if (item?.content?.hashtags?.length > 0) {
                item.content.hashtags.forEach((h) => {
                    const text = h?.text || '';
                    const value = h?.value || 0;
                    if (text) {
                        hashtagMap[text] = (hashtagMap[text] || 0) + value;
                    }
                })
            }
        })
        return Object.entries(hashtagMap).map(([text, value]) => ({ text, value }));
    }

    const allHashtags = getAllHashtags();

    const links = [
        { label: 'Platforms', href: '#platforms', icon: profilePlatformIcon },
        { label: 'Content', href: '#content', icon: imageIconBlack },
        { label: 'Brands', href: '#brands', icon: tagIcon }
    ];

    const getProfileUrl = (item) => {
        if (item.platformType === 'instagram') {
            return influencerDetails?.profile_url || `https://instagram.com/${item.handleName}/`;
        }
        return `https://youtube.com/${item.handleName}/`;
    }

    const onSmoothClick = (e, href) => {
        const id = href.replace("#", "")
        const parentEle = document.getElementById('parent');
        const childEle = document.getElementById(id);
        setChileElementIdForScroll('#' + id);
        if (parentEle && childEle) {
            parentEle.scrollTop = childEle.offsetTop
            e.preventDefault()
            parentEle.scrollIntoView({
                behavior: "smooth",
            })
        }
    }

    return (
        <>
            <Stack direction={"row"} padding={'0px 16px'} position={"relative"} sx={{ height: isScreenZoomed ? '65vh' : '69vh' }}>
                <Box sx={{ width: '15%', height: '100%', position: 'sticky', top: 0, paddingTop: '20px' }}>
                    <Stack direction={"column"} gap={2}>
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={(e) => onSmoothClick(e, l.href)}
                                style={{ display: 'flex', flexDirection: 'row', gap: '10px', textDecoration: 'none', alignItems: 'center' }}
                            >
                                <img src={l.icon} alt={l.icon} style={{
                                    height: '20px', width: '20px', filter:
                                        childElementIdForScroll === l.href
                                            ? "brightness(0) saturate(100%) invert(38%) sepia(95%) saturate(7485%) hue-rotate(202deg) brightness(103%) contrast(104%)"
                                            : "brightness(0)",
                                }} />
                                <Typography fontSize={16} fontWeight={400} color={childElementIdForScroll === l.href ? "var(--color-blue)" : '#726C6C'}>{l.label}</Typography>
                            </a>
                        ))}
                    </Stack>
                </Box>
                <Box sx={{
                    width: '85%', height: '100%', overflowY: 'scroll', position: 'relative', borderLeft: '1px solid #F0F0F0',
                    scrollBehavior: 'smooth', overscrollBehavior: 'contain', padding: '0px 20px 0 40px'
                }} id="parent" ref={contentRef}>
                    <Box id='platforms' paddingTop={'20px'}>
                        {details?.map((item, index) => (
                            <Box key={index} sx={{ boxShadow: '0 0 24px 0 rgba(0, 0, 0, 0.10)', background: 'white', borderRadius: '8px', width: '100%', padding: '20px', marginY: index > 0 ? '40px' : '0', borderBottom: item.platformType === 'instagram' ? '2px solid var(--color-blue)' : '2px solid #F00' }}>
                                <Stack direction={"row"} gap={1} justifyItems={"flex-start"} alignItems={"center"} paddingBottom={'20px'}>
                                    <img src={item.platformType === 'instagram' ? instagramIcon : youtubeIcon} alt={item.platformType} style={{ height: '24px', width: '24px' }} />
                                    <Typography sx={{ fontSize: '16px', fontWeight: 400, color: 'black' }}>{item.handleName}</Typography>
                                    <a href="/" onClick={(e) => { e.preventDefault(); window.open(getProfileUrl(item), "_blank"); }} target='_blank' rel="noreferrer">
                                        <img src={linkIcon} alt="link" style={{ height: '18px', width: '18px' }} />
                                    </a>
                                </Stack>
                                <Stack direction={"row"} width={"100%"} justifyContent={"space-between"} alignItems={"center"}>
                                    <Stack direction={'column'} gap={1} >
                                        <Typography fontSize={14} fontWeight={300} color={"black"}>{SOCIAL_PLATEFORM.YOUTUBE === item.platformType ? "Subscribers" : "Followers"}</Typography>
                                        <Typography fontSize={14} fontWeight={500} color={"black"}>{getFixedValue(item.followers) || 'N/A'}</Typography>
                                    </Stack>
                                    <Stack direction={'column'} gap={1} >
                                        <Typography fontSize={14} fontWeight={300} color={"black"}>{SOCIAL_PLATEFORM.YOUTUBE === item.platformType ? "Total Videos" : "Avg. Likes"}</Typography>
                                        <Typography fontSize={14} fontWeight={500} color={"black"}>{SOCIAL_PLATEFORM.YOUTUBE === item.platformType ? (item?.video_count || 'N/A') : getFixedValue(item?.Engagement?.posts?.avg_likes) || "N/A"}</Typography>
                                    </Stack>
                                    {SOCIAL_PLATEFORM.YOUTUBE === item.platformType && <Stack direction={'column'} gap={1} >
                                        <Typography fontSize={14} fontWeight={300} color={"black"}>{"Avg. Likes"}</Typography>
                                        <Typography fontSize={14} fontWeight={500} color={"black"}>{getFixedValue(item?.Engagement?.posts?.avg_likes) || 'N/A'}</Typography>
                                    </Stack>}
                                    <Stack direction={'column'} gap={1} >
                                        <Typography fontSize={14} fontWeight={300} color={"black"}>Avg. Comments</Typography>
                                        <Typography fontSize={14} fontWeight={500} color={"black"}>{getFixedValue(item?.Engagement?.posts?.avg_comments) || 'N/A'}</Typography>
                                    </Stack>
                                    <Stack direction={'column'} gap={1} >
                                        <Typography fontSize={14} fontWeight={300} color={"black"}>{SOCIAL_PLATEFORM.YOUTUBE === item.platformType ? "Avg. Views" : "Avg. Reel Views"}</Typography>
                                        <Typography fontSize={14} fontWeight={500} color={"black"}>{getFixedValue(item?.Engagement?.posts?.avg_views) || "N/A"}</Typography>
                                    </Stack>
                                    {SOCIAL_PLATEFORM.INSTAGRAM === item.platformType &&
                                        <Stack direction={'column'} gap={1} >
                                            <Typography fontSize={14} fontWeight={300} color={"black"}>Engagement Rate &nbsp;<Tooltip componentsProps={TOOLTIP_STYLES} arrow title="Engagement rate shows the percent of the audience who engages with the content posted by this influencer. It is calculated as average engagement (likes + comments) divided by follower count, and then multiply by 100 to give you a percentage." placement="top-start"><img src={infoIcon} alt='infoicon' style={{ width: '20px', height: '20px' }} /></Tooltip></Typography>
                                            <Typography fontSize={14} fontWeight={500} color={"black"}>{item?.overview?.engagement_rate ? Number(item.overview.engagement_rate).toFixed(2) + "%" : "N/A"}</Typography>
                                        </Stack>
                                    }
                                </Stack>
                            </Box>
                        ))}
                    </Box>
                    <Box id='content' paddingTop={"20px"}>
                        <Stack direction={"row"} gap={1} alignItems={"center"}>
                            <img src={imageIconBlack} style={{ width: '24px', height: '24px' }} alt="content" />
                            <Typography fontSize={20} fontWeight={600} color={"black"}>Content</Typography>
                        </Stack>
                        <Stack direction={"row"} gap={1} alignItems={"center"} marginTop={'24px'}>
                            <Typography fontSize={16} fontWeight={400} color={"#726C6C"}>HASHTAGS</Typography>
                        </Stack>
                        <Grid container>
                            {
                                (Array.isArray(allHashtags) ? [...allHashtags].sort((a, b) => b.value - a.value).slice(0, showAllHastags ? 26 : 11) : []).map((item, index) => (
                                    <Grid key={item?.text + index} item xs={4} sx={{ height: '50px', padding: '0 30px 0 0' }}>
                                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ borderBottom: '1px solid #F0F0F0', paddingY: '20px', height: '100%' }}>
                                            <Stack direction="row" gap={1} alignItems='center'>
                                                <Typography fontSize="16px" fontWeight={400}>{index + 1}.</Typography>
                                                <Typography fontSize="16px" fontWeight={400}>{item?.text}</Typography>
                                            </Stack>
                                            <Typography color="#9F9C9C" fontSize="14px" fontWeight={400}>{item?.value ? `${item.value} Post` : ''}</Typography>
                                        </Stack>
                                    </Grid>
                                ))
                            }
                            {allHashtags?.length > 11 && <Grid item xs={4} sx={{ height: '50px', padding: 0 }}>
                                <Stack direction="row" justifyContent="flex-end" alignItems="center" sx={{ paddingY: '20px', height: '100%', borderBottom: '1px solid #F0F0F0' }}>
                                    <Button onClick={() => setShowAllHastags(prev => !prev)} disableRipple sx={{
                                        "&:hover": { background: 'none' }
                                    }}>
                                        <Typography sx={{ fontSize: "16px", fontWeight: 400, color: 'var(--color-blue)' }}>
                                            {showAllHastags ? "See Less" : "See All"}
                                        </Typography>
                                    </Button>
                                </Stack>
                            </Grid>}
                            {allHashtags?.length === 0 && (
                                <Grid item xs={12} sx={{ padding: '20px 0' }}>
                                    <Typography fontSize={14} fontWeight={400} color={"#726C6C"}>No hashtag data available</Typography>
                                </Grid>
                            )}
                        </Grid>
                        <Box paddingTop={"40px"}>
                            <Typography fontSize={16} fontWeight={400} color={"#726C6C"} paddingBottom={"16px"}>TOP POSTS</Typography>
                            {details?.[0]?.content?.[overviewPostTab]?.length > 0 ? <>
                                <Stack direction={"row"} justifyContent={"flex-end"} alignItems={"center"} paddingBottom={"16px"}>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', border: '1px solid #EEE', padding: '4px', borderRadius: '4px' }}>
                                        <Stack direction="row" spacing={1}>
                                            <Button onClick={() => setOverviewPostTab("topMostPost")} sx={{
                                                color: overviewPostTab === "topMostPost" ? "white" : 'black', background: overviewPostTab === "topMostPost" ? "var(--color-blue)" : 'white', borderRadius: '4px', "&:hover": { background: 'var(--color-blue)', "& p": { color: 'white' } }
                                            }}><Typography fontSize={12} fontWeight={500} color={overviewPostTab === "topMostPost" ? "white" : 'black'}>Top Posts</Typography></Button>
                                            <Button onClick={() => setOverviewPostTab("topRecentPost")} sx={{
                                                color: overviewPostTab === "topRecentPost" ? "white" : 'black', background: overviewPostTab === "topRecentPost" ? "var(--color-blue)" : 'white', borderRadius: '4px', "&:hover": { background: 'var(--color-blue)', "& p": { color: 'white' } }
                                            }}><Typography fontSize={12} fontWeight={500} color={overviewPostTab === "topRecentPost" ? "white" : 'black'}>Recent Posts</Typography></Button>
                                        </Stack>
                                    </Box>
                                </Stack>
                                <Carousel responsive={responsive} itemClass="carousel-item-padding-40-px">
                                    {details[0].content[overviewPostTab].slice(0, 12).map((post, index) => (
                                        <Box key={post.id || index} sx={{ width: '280px', borderRadius: '4px', overflow: 'hidden', cursor: post.shortcode ? 'pointer' : 'default' }}
                                            onClick={() => { if (post.shortcode) window.open(post.shortcode, "_blank"); }}>
                                            <Box sx={{ width: '100%', height: '240px', overflow: 'hidden', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                {post.media_type === 2 ? (
                                                    <video src={post.thumbnailSrc} style={{ width: '100%', height: '100%', objectFit: 'cover' }} muted preload="metadata" />
                                                ) : post.thumbnailSrc ? (
                                                    <img src={post.thumbnailSrc} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                ) : (
                                                    <Typography fontSize={12} color={"#999"}>No preview</Typography>
                                                )}
                                            </Box>
                                            <Stack sx={{ background: 'black', borderRadius: '0 0 4px 4px', padding: '8px' }} justifyContent={"space-between"} alignItems={"center"} direction={"row"}>
                                                <Stack direction={"row"} gap={1} justifyContent={"flex-start"} alignItems={"center"}>
                                                    <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                                                        <img src={likeIcon} alt="likes" style={{ filter: 'brightness(0) invert(1)', height: '14px', width: '14px' }} />
                                                        <Typography fontSize={11} fontWeight={500} color={'white'}>{getFixedValue(post.previewLikeCount)}</Typography>
                                                    </Stack>
                                                    <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                                                        <img src={eyeIcon} alt="views" style={{ filter: 'brightness(0) invert(1)', height: '14px', width: '14px' }} />
                                                        <Typography fontSize={11} fontWeight={500} color={'white'}>{getFixedValue(post.viewCount)}</Typography>
                                                    </Stack>
                                                    <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                                                        <img src={profileCommentIcon} alt="comments" style={{ filter: 'brightness(0) invert(1)', height: '14px', width: '14px' }} />
                                                        <Typography fontSize={11} fontWeight={500} color={'white'}>{getFixedValue(post.commentCount)}</Typography>
                                                    </Stack>
                                                </Stack>
                                                <Typography fontSize={11} fontWeight={500} color={"white"}>{getDateformatUsingSeconds(post.timestamp)}</Typography>
                                            </Stack>
                                        </Box>
                                    ))}
                                </Carousel>
                            </> : <Box sx={{ padding: '20px', border: '1px solid #F0F0F0', borderRadius: '8px', textAlign: 'center' }}>
                                <Typography fontSize={14} fontWeight={400} color={"#726C6C"}>No posts data available</Typography>
                            </Box>}
                        </Box>
                    </Box>
                    <Box id='brands' paddingTop={"60px"}>
                        <Brands brands={details?.map((v) => v?.Brands || [])?.flat().filter((v, i, self) => i == self.findIndex((vv) => v?.Name === vv?.Name))} handleId={details[0]?.handleRecordId || 0} userId={0} />
                    </Box>
                </Box>
            </Stack>
        </>
    );
};

export default UltimateProfileSummary;